/* ============================================================
   vm150-packs.js — Velomorph
   1. Les cartes de packs pilotent le selecteur natif de Dawn.
   2. La date de livraison remonte sous "Envio gratuito".
   3. Le bloc de compatibilite descend sous le panneau bleu.

   Les points 2 et 3 sont faits en JS parce que la reassurance
   vit dans un bloc "Liquid personnalise" du gabarit, qui ne peut
   pas etre modifie par fichier. Les deux deplacements sont
   idempotents et sans effet si leur cible est absente : rien ne
   disparait jamais si le JS echoue, l'ordre est seulement celui
   d'origine.
   ============================================================ */
(function () {
  'use strict';

  function scopeOf(el) {
    return el.closest('product-info') || el.closest('.product') || document;
  }

  function nativePickerIn(scope) {
    return scope.querySelector(
      'variant-selects, .product-form__input--pill, .product-form__input--dropdown'
    );
  }

  /* ---- Klarna ------------------------------------------------ */

  function refreshKlarna() {
    if (window.Klarna &&
        window.Klarna.OnsiteMessaging &&
        typeof window.Klarna.OnsiteMessaging.refresh === 'function') {
      window.Klarna.OnsiteMessaging.refresh();
      return true;
    }
    return false;
  }

  function renderKlarna(wrap, cents) {
    if (!wrap) return;
    if (wrap.getAttribute('data-amount') === String(cents)) return;
    wrap.setAttribute('data-amount', String(cents));
    // Klarna ne relit pas un data-purchase-amount modifie :
    // il faut detruire et recreer l'element.
    wrap.innerHTML = '';
    var el = document.createElement('klarna-placement');
    el.setAttribute('data-key', wrap.getAttribute('data-key'));
    el.setAttribute('data-locale', wrap.getAttribute('data-locale'));
    el.setAttribute('data-purchase-amount', String(cents));
    wrap.appendChild(el);
    refreshKlarna();
  }

  /* ---- Selecteur natif --------------------------------------- */

  function selectNative(scope, optionValue) {
    var picker = nativePickerIn(scope);
    if (!picker) return;
    var els = picker.querySelectorAll('input[type="radio"], option');
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      if (String(el.value == null ? '' : el.value).trim() !== optionValue) continue;
      if (el.tagName === 'OPTION') {
        var sel = el.closest('select');
        if (!sel || sel.value === el.value) return;
        sel.value = el.value;
        sel.dispatchEvent(new Event('change', { bubbles: true }));
      } else if (!el.checked) {
        el.checked = true;
        el.dispatchEvent(new Event('change', { bubbles: true }));
      }
      return;
    }
  }

  /* ---- Rendu des cartes -------------------------------------- */

  function cardsIn(root) {
    return Array.prototype.slice.call(root.querySelectorAll('[data-vm150-card]'));
  }

  function paint(root, card) {
    cardsIn(root).forEach(function (c) {
      var on = c === card;
      c.classList.toggle('is-selected', on);
      var r = c.querySelector('.vm150-packs__radio');
      if (r) r.checked = on;
    });
    renderKlarna(root.querySelector('[data-vm150-klarna]'), card.getAttribute('data-price'));
  }

  /* ---- Evenements (delegation) ------------------------------- */

  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;

    var radio = t.closest('.vm150-packs__radio');
    if (radio) {
      var root = radio.closest('[data-vm150-packs]');
      var card = radio.closest('[data-vm150-card]');
      if (!root || !card) return;
      paint(root, card);
      selectNative(scopeOf(root), card.getAttribute('data-option-value'));
      return;
    }

    var scope = t.closest('product-info') || t.closest('.product');
    if (!scope) return;
    var packs = scope.querySelector('[data-vm150-packs]');
    if (!packs || packs.contains(t)) return;
    var val = String(t.value == null ? '' : t.value).trim();
    var match = cardsIn(packs).filter(function (c) {
      return c.getAttribute('data-option-value') === val;
    })[0];
    if (match) paint(packs, match);
  });

  /* ---- Styles des elements deplaces -------------------------- */
  /* Alignement de la date sur "Envio gratuito" :
     la ligne envoi vaut icone 22px + gouttiere 10px, donc son
     texte commence a 32px. On reconstitue la meme colonne pour
     la date : 6px + pastille 9px + 17px = 32px, pastille centree
     dans la colonne de l'icone. En mobile : 20px + 9px = 29px,
     reconstitue par 5px + 9px + 15px.
     !important parce que le <style> du bloc d'origine est dans
     le body, donc apres celui-ci dans la cascade. */

  function injectStyles() {
    if (document.getElementById('vm150-moved-styles')) return;
    var css = [
      '.vm150-payment > .vm150-delivery {',
      '  margin: 7px 0 0 !important;',
      '  padding-left: 6px !important;',
      '  gap: 17px !important;',
      '  align-items: flex-start;',
      '}',
      '.vm150-payment > .vm150-delivery .vm150-dot {',
      '  flex: 0 0 9px !important;',
      '  width: 9px; height: 9px;',
      '  margin-top: 7px !important;',
      '}',
      '.vm150-payment > .vm150-delivery .vm150-copy {',
      '  font-size: 15px; line-height: 1.5;',
      '}',
      '@media (max-width: 749px) {',
      '  .vm150-payment > .vm150-delivery {',
      '    margin: 6px 0 0 !important;',
      '    padding-left: 5px !important;',
      '    gap: 15px !important;',
      '  }',
      '  .vm150-payment > .vm150-delivery .vm150-dot { margin-top: 6px !important; }',
      '  .vm150-payment > .vm150-delivery .vm150-copy { font-size: 13.5px; }',
      '}',
      '.vm150-block .vm150-fit { margin: 14px 0 0; }'
    ].join('\n');
    var s = document.createElement('style');
    s.id = 'vm150-moved-styles';
    s.textContent = css;
    document.head.appendChild(s);
  }

  /* ---- Deplacements ------------------------------------------ */

  function moveDelivery() {
    var delivery = document.querySelector('.vm150-block .vm150-delivery');
    var shipping = document.querySelector('.vm150-block .vm150-shipping');
    if (!delivery || !shipping) return;
    if (shipping.nextElementSibling === delivery) return;
    shipping.insertAdjacentElement('afterend', delivery);
  }

  function moveFit() {
    var fit = document.querySelector('.vm150-fit');
    if (!fit) return;
    var trial = document.querySelector('.vm150-block .vm150-trial');
    if (!trial || trial.nextElementSibling === fit) return;
    trial.insertAdjacentElement('afterend', fit);
  }

  /* ---- Masquage du selecteur natif --------------------------- */

  var pending = false;
  function settle() {
    pending = false;
    var roots = document.querySelectorAll('[data-vm150-packs]');
    for (var i = 0; i < roots.length; i++) {
      var p = nativePickerIn(scopeOf(roots[i]));
      if (p && p.style.display !== 'none') p.style.display = 'none';
    }
    moveDelivery();
    moveFit();
  }
  function queueSettle() {
    if (pending) return;
    pending = true;
    // setTimeout plutot que requestAnimationFrame : rAF ne se
    // declenche pas dans un onglet en arriere-plan.
    setTimeout(settle, 0);
  }

  /* ---- Init -------------------------------------------------- */

  function init() {
    injectStyles();

    if (document.querySelector('[data-vm150-packs]')) {
      document.documentElement.classList.add('vm150-ready');
      var roots = document.querySelectorAll('[data-vm150-packs]');
      for (var i = 0; i < roots.length; i++) {
        var root = roots[i];
        var card = root.querySelector('[data-vm150-card].is-selected') ||
                   root.querySelector('[data-vm150-card]');
        if (!card) continue;
        paint(root, card);
        selectNative(scopeOf(root), card.getAttribute('data-option-value'));
      }
    }

    settle();

    if (window.MutationObserver) {
      new MutationObserver(queueSettle).observe(document.body, {
        childList: true,
        subtree: true
      });
    }

    [150, 600, 1500, 3000].forEach(function (d) { setTimeout(settle, d); });

    var tries = 0;
    var timer = setInterval(function () {
      tries += 1;
      if (refreshKlarna() || tries > 20) clearInterval(timer);
    }, 500);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
